if(window.location.pathname.split('/')[2] == 'globo_basis_collection') {
 	 window.location.href = window.location.protocol + "//" + window.location.host+'/collections/all';
}
// if(window.location.pathname.split('/')[1] == 'collections' && window.location.pathname.split('/')[2] == undefined) {
//   window.location.href = window.location.protocol + "//" + window.location.host;
// }
function myFunction(){
  document.querySelector(".video-popup").style.display = "flex";
}
function myFunction1(){
  document.querySelector(".video-popup").style.display = "none";
}


//     $(document).ready(function(){
//     $('.slider-for').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         fade: true,
//         asNavFor: '.slider-nav'
//     });
// });





